<template>
  <div id="app">
     <NavigationBar></NavigationBar>
    <div id="app-body">
      <router-view  ref="router"></router-view>
    </div>

    
    <Footer></Footer>
  </div>
</template>

<script>
import NavigationBar from './components/NavigationBar.vue'
// import Footer from './components/Footer.vue'

export default {
  name: 'app',
  components: {
    NavigationBar
    // Footer
  }
}

</script>
<style>
  #app-body{
  min-height:70vh;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: 'Helvetica', sans-serif;
  font-style: normal;
  font-size: 14.5px;
  line-height: 1.4em;
  font-weight: 400;
  color: black;
  margin-top:50px;
}
svg,
g {
  overflow: visible;
}
.section{
  margin-top:100px;
}
section{
  margin-top:50px !important;
  margin-bottom:50px !important;
}

h1 {
  font-size: 2em;
  line-height: 1.35em;
  font-weight: 900;
  margin: 0em 0em 1em 0em;
}

h2{
  font-size: 1.4em;
  line-height: 1em;
  font-weight: 900;
  margin: 0em 0em .5em 0em;
  text-transform: none;
}
h3,
.accordion-button,
.column-title,
.row-title,
.plot-title {
  font-size: 1em !important;
  line-height: 1.4em !important;
  font-weight: 900 !important;
  margin: 0em 0em .5em 0em !important;
  padding-left: 0px !important;
}
h4 {
  font-size: 1em;
  line-height: 1.4em;
  font-weight: 400;
  margin: 0em 0em .5em 0em;
  border-bottom:.25px solid black;
  display:inline-block !important;
}

p {
  font-size: 1em;
  line-height: 1.4em;
  margin: 0em 0em 0em 0em;
}

h5 {
  font-size: .75em;
  line-height: 1.4em;
  font-weight: 800;
  margin: 0em 0em .5em 0em;
  padding-top:.5em;
  text-transform: uppercase;
  border-top:.1px solid black;
  
}

ul{
  margin-left:0px;
}
li{
  font-size: .9em;
  line-height: 1.4em;
  margin: 0em 0em 0.25em 0em;
}
a{
  color:#0083C7;
  text-decoration: none;
  border-bottom:.1px solid #0083C7;
}
a:hover{
  text-decoration: none;
  opacity:.8;
}
select:focus,
.btn:focus,
.btn-outline-primary:focus,
button {
  box-shadow: none !important;
}

</style>